export default function APIError(apiError) {
  this.status = apiError?.response?.code || 'error';
  this.code = apiError?.response?.status || 403;
  this.message = apiError?.response?.data?.message || 'Unknown error';

  // this.toString = function() {
  //   return this.value + this.message;
  // };
}